/* eslint-disable quotes */
import { h } from 'vue';

const body = `<h4>View top (down the Z axis)</h4>

<p>Switch view down the Z axis. Click again to switch to opposite (-Z) view direction.</p>

<p>Clicking on the orthogonal plane also flips view between Z and -Z direction</p>

<p>The up/down-arrow and left/right-arrow keys rotate view by 15 degrees.</p>`;

export default function ViewZTooltip() {
    return h('div', { innerHTML: body });
}
